export enum PermissionResourceEnum {
  PROVIDER = "provider",
  SERVICE = "service",
  CLIENT = "client",
  ASSIGNMENT = "assignment",
  ORDER = "order",
  CASE = "case",
  RFQ = "rfq",
  REPORTS = "reports",
  CATEGORY = "category",
  AD = "ad",
  MESSAGE = "message",
  USER = "user",
  ADMIN = "admin",
  EXPAT = "expat",
  NOTIFICATION = "notification",
}

export enum PermissionSecondaryResourceEnum {
  DETAILS = "details",
  INVITES = "invites",
  FINANCIAL = "financial",
  // The gateway grants "manage notification templates" / "publish
  // notification templates"; $can joins action + resource + secondary with
  // single spaces, so "notification" + "templates" reproduces those exactly.
  TEMPLATES = "templates",
}

export enum PermissionActionEnum {
  VIEW = "view",
  CREATE = "create",
  UPDATE = "update",
  DELETE = "delete",
  MANAGE = "manage",
  // "publish notification templates" — the gateway splits publishing (and
  // layout deletion, which sits with publish rights) from managing drafts.
  PUBLISH = "publish",
  DOWNLOAD = "download",
}
